"use strict";

var _interopRequireWildcard = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.filterAsyncRoutes = filterAsyncRoutes;
exports.mapAsyncRoutes = mapAsyncRoutes;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/es7.array.includes");
require("core-js/modules/web.dom.iterable");
var _router = _interopRequireWildcard(require("@/router"));
var _index = require("@/utils/index");
/**
  route 由后台控制， 前台不管理role
 */

/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
// function hasPermission(roles, route) {
//   if (route.meta && route.meta.roles) {
//     return roles.some(role => route.meta.roles.includes(role))
//   } else {
//     return true
//   }
// }
// 是路由菜单，不在sidebar展示，但也需保留redirect，防止空白页
var navbarList = ['taskModule', 'likeCommendModule'];
/**
 * Filter asynchronous routing tables
 */
function filterAsyncRoutes(asyncRoutes, serviceRoutes) {
  var res = [];
  serviceRoutes.forEach(function (serviceRoute) {
    var serviceTmp = serviceRoute;
    asyncRoutes.forEach(function (asyncRoute) {
      var tmp = asyncRoute;
      if (tmp.path === serviceTmp.path) {
        if (serviceTmp.children) {
          tmp.children = filterAsyncRoutes(tmp.children, serviceTmp.children);
        }
        res.push(tmp);
      }
    });
  });
  return res;
}
function mapAsyncRoutes(routeMap, serviceRoutes) {
  var root = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  serviceRoutes.forEach(function (item, index) {
    if (root) {
      item.path = "/".concat(item.path);
    }

    // 无children 、redirect==='noRedirect'
    if (!item.children || item.redirect === 'noRedirect') {
      delete item['redirect'];
    }

    // 子菜单全部都是虚拟菜单
    if (item.children) {
      var hasNormalRoute = item.children.some(function (child) {
        return child.isVirtual && child.isVirtual === 'N';
      });
      if (!hasNormalRoute && !navbarList.includes(item.name)) {
        delete item['redirect'];
      }
    }
    if (item.redirect && item.redirect !== 'noRedirect') {
      item.redirect = "/".concat(item.redirect);
    }
    item.component = routeMap[item.component];
    if (item.children && item.children.length > 0) {
      mapAsyncRoutes(routeMap, item.children);
    }
  });
  return serviceRoutes;
}
var state = {
  routes: [],
  addRoutes: [],
  originBackRoutes: [],
  functions: [],
  homeType: ''
};
var mutations = {
  SET_BACK_ROUTES: function SET_BACK_ROUTES(state, routes) {
    state.originBackRoutes = routes;
  },
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = _router.constantRoutes.concat(routes);
  },
  SET_FUNCTIONS: function SET_FUNCTIONS(state, functions) {
    state.functions = functions;
  },
  ADD_FUNCTIONS: function ADD_FUNCTIONS(state, functions) {
    state.functions = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, state.functions), functions);
  },
  SET_HOMETYPE: function SET_HOMETYPE(state, type) {
    state.homeType = type;
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, routes) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var serviceRoutes = [];
      var tmpRoutes = routes || [];
      commit('SET_BACK_ROUTES', (0, _index.deepClone)(tmpRoutes) || []);
      (0, _router.resetRouter)();
      if (tmpRoutes && tmpRoutes.length > 0) {
        // 处理后台返回的数据
        serviceRoutes = mapAsyncRoutes(_router.routeMap, tmpRoutes, true);
      }

      // serviceRoutes.push({ path: '*', redirect: '/404', hidden: true })

      _router.default.addRoutes(serviceRoutes);
      console.log('serviceRoutes', serviceRoutes);
      commit('SET_ROUTES', serviceRoutes);
      resolve(serviceRoutes);
    });
  },
  generateFunctions: function generateFunctions(_ref2, functions) {
    var commit = _ref2.commit;
    commit('SET_FUNCTIONS', functions);
  },
  /**
   * cwt使用
  */
  addFunctions: function addFunctions(_ref3, functions) {
    var commit = _ref3.commit;
    commit('ADD_FUNCTIONS', functions);
  },
  setHomeType: function setHomeType(_ref4, type) {
    var commit = _ref4.commit;
    commit('SET_HOMETYPE', type);
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};